
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 17.354c-.222 0-.434-.042-.635-.125a1.871 1.871 0 01-.552-.354l-6.688-6.688a1.871 1.871 0 01-.354-.552A1.646 1.646 0 01.646 9c0-.222.042-.438.125-.646.083-.208.201-.389.354-.542l6.688-6.687c.166-.167.35-.288.552-.365a1.862 1.862 0 011.281 0c.208.077.389.198.542.365l6.687 6.687c.167.153.288.334.365.542a1.861 1.861 0 010 1.281 1.56 1.56 0 01-.365.552l-6.687 6.688c-.153.153-.334.27-.542.354a1.724 1.724 0 01-.646.125zm-.833-7.52h1.667v-5H8.167v5zm.833 2.5c.236 0 .434-.08.594-.24.16-.16.24-.358.24-.594a.806.806 0 00-.24-.594.806.806 0 00-.594-.24.806.806 0 00-.594.24.806.806 0 00-.24.594c0 .236.08.434.24.594.16.16.358.24.594.24z"}})])
          )
        }
      }
    